import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HelmetProvider } from "react-helmet-async";

const rootElement = document.getElementById('root');

// The App component wrapped in the Provider
const AppInstance = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// React 19 Hydration Logic
if (rootElement.hasChildNodes()) {
  // Use hydrateRoot if react-snap has already generated the HTML
  ReactDOM.hydrateRoot(rootElement, AppInstance);
} else {
  // Use createRoot for normal development/first-time render
  const root = ReactDOM.createRoot(rootElement);
  root.render(AppInstance);
}